"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
GroupController.$inject = ['$scope', 'api', 'group', 'products', '_shop', '$location', '_product'];
function GroupController($scope, api, group, products, _shop, $location, _product) {
    $scope.group = group;
    $scope.description = group.description;
    $scope.title = group.name;
    $scope.mobile_title = group.name;
    $scope.products = products.items;
    _product.setList($scope.products);
    $scope.showFilters = false;
    $scope.$watch('showFilters', function (val) {
        $scope.showFilters = val;
    });
    $scope.sortArray = _shop.getSortTypes();
    $scope.sortItems = {};
    $scope.sortProducts = function (item) {
        $scope.sortItems = item;
        lodash_1.default.each($scope.sortArray, function (child, index) {
            child.active = 0;
        });
        item.active = 1;
    };
    $scope.openModal = function (product, index) {
        $location.search('productView', product._id);
        _product.viewProduct(product, index, null);
    };
}
exports.GroupController = GroupController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/group/controllers/GroupController.js
// module id = 480
// module chunks = 0